export default __webpack_public_path__ + "static/media/AmineBenaceurResume.ed3af260.pdf";